import type {
  ApiOrgTermsOfUse,
  ApiSaveOrgTermsOfUse,
  ApiMarketplaceTermsOfUse,
  ApiPurchaseTermsOfUse,
  ApiOrgTermsOfUseStatus,
  ApiTrainerTermsOfUse,
} from '../schemas/termsOfUse.schema';
import type { BaseApiResponse } from './types/api.types';

import { post, get } from './axios';

const baseUrl = (organizationId: string) =>
  `/v2/organizations/${organizationId}/terms-of-use`;

export async function fetchOrgTermsOfUse({
  organizationId,
}: {
  organizationId: string;
}) {
  const response = await get<BaseApiResponse<ApiOrgTermsOfUse>>(
    `${baseUrl(organizationId)}/current`,
  );
  return response?.data ?? null;
}

export async function fetchOrgTermsOfUseStatus({
  organizationId,
}: {
  organizationId: string;
}) {
  const response = await get<BaseApiResponse<ApiOrgTermsOfUseStatus>>(
    `${baseUrl(organizationId)}/status`,
  );
  return response?.data ?? null;
}

export async function fetchTrainerTermsOfUse({
  organizationId,
}: {
  organizationId: string;
}) {
  const response = await get<BaseApiResponse<ApiTrainerTermsOfUse[]>>(
    `${baseUrl(organizationId)}/trainers`,
  );
  return response?.data ?? [];
}

export async function saveOrgTermsOfUse({
  organizationId,
  data,
}: {
  organizationId: string;
  data: ApiSaveOrgTermsOfUse;
}) {
  const response = await post<ApiOrgTermsOfUse>(baseUrl(organizationId), data);
  return response?.data ?? null;
}

export async function requestTermsOfUseContactEmailVerification({
  organizationId,
  contactEmail,
}: {
  organizationId: string;
  contactEmail: string;
}) {
  await post(`${baseUrl(organizationId)}/contact-email-verification`, {
    contactEmail,
  });
}

export async function confirmTermsOfUseContactEmail({
  hash,
}: {
  hash: string;
}) {
  await get(`/v2/terms-of-use/confirm-contact-email`, { query: { hash } });
}

export async function fetchMarketplaceItemTermsOfUse({
  marketplaceId,
}: {
  marketplaceId: string;
}) {
  const response = await get<BaseApiResponse<ApiMarketplaceTermsOfUse | null>>(
    `/v2/marketplace/${marketplaceId}/terms-of-use`,
  );
  return response?.data ?? null;
}

export async function fetchMarketplacePurchaseTermsOfUse({
  purchaseId,
}: {
  purchaseId: string;
}) {
  const response = await get<BaseApiResponse<ApiPurchaseTermsOfUse>>(
    `/v2/payments/marketplace/purchases/${purchaseId}/terms-of-use`,
  );
  return response?.data ?? null;
}
